import React, { Component } from 'react';
import styled from 'styled-components';

const StyledForm = styled.form`
  padding: 0px 16px;
  display: block;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;

class Form extends Component {
  render() {
    return <StyledForm autoComplete="off" {...this.props} />;
  }
}

export default Form;
